
import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const SubmitButton = (props) => {
    const { translate: t } = useLocale();

    return (
        <button
            className='bg-brand-500 rounded-button text-white type-style-body-small px-16 py-14'
            {...props}
            type='submit'>
            {props.children || t('FORM_SUBMISSION_BTN_LABEL')}
        </button>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

SubmitButton.propTypes = {
    children: PropTypes.any
};

export default SubmitButton;
